import Tracked from 'editor/utils/Tracked';
import mapboxgl from 'mapbox-gl';

interface MapboxLayerTracked extends Record<string, unknown> {
  layer: mapboxgl.Layer;
}

class MapboxLayer extends Tracked<MapboxLayerTracked> {
  updatedFields = new Set();

  added = false;

  constructor(layer: mapboxgl.Layer) {
    super({ layer });

    this.tracked.layer = layer;
  }

  didUpdate(prop: string): void {
    this.updatedFields.add(prop);
  }
}

export default MapboxLayer;
